import { Col, Container, Row } from "react-bootstrap";
import '../css/docs.css'

const Docs = () => {
    return (
        <Container style={{maxWidth: 1200}}>
            <Row className="d-flex justify-content-center mb-5">
                <Col>
                    <h1 className="docs_h1">
                        Публичная оферта и политика конфиденциальности
                    </h1>
                    <p style={{textAlign: 'center'}}>Настоящий документ – это публичная оферта (предложение) интернет-магазина укажите домен магазина или его название о продаже товаров.</p>
                </Col>
            </Row>
        </Container>
    );
}
export default Docs;